export default __webpack_public_path__ + "static/media/create-therapist.4dba49b2.webp";